/** Galerija ture (privatne fotografije) — putopis koristi zasebno VALENCIA_TRAVELOGUE_GALLERY u valenciaTravelogueMedia.js */
export const VALENCIA_TOUR_GALLERY = [
  "/images/valencia/1000243378.jpg",
  "/images/valencia/1000243443.jpg",
  "/images/valencia/1000244171.jpg",
  "/images/valencia/1000247904.jpg",
  "/images/valencia/1000247906.jpg",
  "/images/valencia/1000247907.jpg",
];

/** Valencia – Las Fallas (privatni aranžman). Ubacuje se ako nedostaje u localStorage ili Supabase. */
export const VALENCIA_TOUR_STATUS_TAG = "POPUNJENO - PRIVATNO";

export const VALENCIA_TOUR = {
  id: 8,
  key: "valencia",
  category: "city",
  days: 4,
  nights: 3,
  country: "Spain",
  date: "2025-03-17",
  price: 0,
  tag: VALENCIA_TOUR_STATUS_TAG,
  image: VALENCIA_TOUR_GALLERY[0],
  blogText: { hr: "", en: "", de: "", es: "" },
  gallery: [...VALENCIA_TOUR_GALLERY],
  detailedInfo: {
    hr: `VALENCIA – LAS FALLAS · FIESTA VALENCIANA (privatni paket aranžman)

📌 NAPOMENA
Ovo putovanje je već realizirano u sklopu privatnog angažmana. Ova stranica služi za predugovorne informacije i arhivu programa.

U Valenciju se ne dolazi samo zbog mora ili hrane – dolazi se zbog osjećaja da se tradicija i suvremeni život ovdje savršeno razumiju.

Grad se otvara polako: jutra s mirisom kave i naranči, šetnja starom jezgrom kroz trgove, katedrale i uske ulice. Zatim futuristički Ciudad de las Artes y las Ciencias – arhitektura kao iz budućnosti.

Las Fallas svake godine u ožujku: gigantske figure (fallas), petarde, vatrometi; vrhunac je La Crema – spaljivanje figura. Više od festivala – slavlje života i zajedništva.

Gastronomija: paella, fideuà, tapas, horchata de chufa. Mercado Central – boje, mirisi, lokalni život.

Smještaj: luksuzni privatni stan u strogom centru (4 odvojene spavaće sobe, prostrani dnevni boravak, potpuno opremljena kuhinja), premium lokacija za vrijeme Fallasa.

🗓 17.03. – 20.03.2025. | 4 dana / 3 noći

✈️ AVIO PRIJEVOZ (indikativno za ovaj aranžman)
Odlazak: Zagreb – Beč – Valencia · Povratak: Valencia – Frankfurt – Zagreb
Jedno presjedanje u svakom smjeru · ručna prtljaga (carry-on) po osobi · redovite linije europskih prijevoznika

🚐 PRIVATNI TRANSFER
Doček u zračnoj luci Valencia, privatno vozilo za 4 osobe, transfer apartman – aerodrom pri povratku

💰 CIJENA
Dogovarala se individualno (na upit) za privatni aranžman.

✅ U SKLADU S PROGRAMOM UKLJUČIVALO JE (indikativno)
Povratne avionske karte s presjedanjima · ručna prtljaga · 4 dana / 3 noći u luksuznom privatnom apartmanu (4 sobe) · privatni transferi · organizacija i asistencija vodiča na hrvatskom i španjolskom

➕ DODATNA ISKUSTVA (na upit)
Izlet u Albuferi · privatna vožnja brodom · gourmet ručkovi i večere · degustacije vina i vinske rute

📞 TraveLina / organizator: info@linatravelina.eu | +385 91 214 447 7`,
    en: `VALENCIA – LAS FALLAS · FIESTA VALENCIANA (private package)

📌 NOTE
This trip has already been carried out as a private engagement. This page keeps pre-contract information and the programme archive.

You don’t come to Valencia only for the sea or food – you come for the feeling that tradition and modern life meet perfectly here.

The city opens slowly: mornings scented with coffee and oranges, walks through the old core, squares, cathedral and narrow lanes. Then the futuristic City of Arts and Sciences – architecture that feels from another time.

Las Fallas each March: giant fallas figures, firecrackers, fireworks; the peak is La Crema, when the figures are burned. More than a festival – a celebration of life and community.

Food: paella, fideuà, tapas, horchata from tiger nuts. Mercado Central – colour, aroma, local life.

Accommodation: luxury private apartment in the strict city centre (4 bedrooms, spacious living room, fully equipped kitchen), premium location for Fallas.

🗓 17–20 March 2025 | 4 days / 3 nights

✈️ FLIGHTS (indicative for this arrangement)
Outbound: Zagreb – Vienna – Valencia · Return: Valencia – Frankfurt – Zagreb
One connection each way · hand luggage (carry-on) per person · scheduled European carriers

🚐 PRIVATE TRANSFER
Meet & greet at Valencia airport, private vehicle for up to 4 people, apartment–airport transfer on return

💰 PRICE
Agreed individually (on request) for the private package.

✅ TYPICALLY INCLUDED (as per programme)
Return flights with connections · hand luggage · 4 days / 3 nights luxury private apartment (4 rooms) · private transfers · organisation and guide assistance in Croatian and Spanish

➕ EXTRA EXPERIENCES (on request)
Albufera excursion · private boat trip · gourmet lunches/dinners · wine tastings and wine routes

📞 TraveLina / organiser: info@linatravelina.eu | +385 91 214 447 7`,
    de: `VALENCIA – LAS FALLAS · FIESTA VALENCIANA (privates Paket)

📌 HINWEIS
Diese Reise wurde bereits im Rahmen eines privaten Auftrags durchgeführt. Diese Seite dient der Archivierung der Vorvertragsinformationen und des Programms.

Man kommt nach Valencia nicht nur wegen Meer oder Essen – sondern weil sich Tradition und modernes Leben hier perfekt begegnen.

Langsam öffnet sich die Stadt: Morgen mit Kaffee- und Orangenduft, Spaziergänge in der Altstadt, dann die futuristische Ciudad de las Artes y las Ciencias.

Las Fallas im März: riesige Fallas-Figuren, Feuerwerk; Höhepunkt ist La Crema. Mehr als ein Fest – ein Erlebnis von Gemeinschaft.

Gastronomie: Paella, Fideuà, Tapas, Horchata. Mercado Central – Farben und lokales Leben.

Unterkunft: luxuriöses Privatapartment im Zentrum (4 Schlafzimmer, Wohnküche, voll ausgestattet), Top-Lage zur Fallas-Zeit.

🗓 17.–20.03.2025 | 4 Tage / 3 Nächte

✈️ FLUG (indikativ)
Hin: Zagreb – Wien – Valencia · Rück: Valencia – Frankfurt – Zagreb
Je ein Umstieg · Handgepäck · Linien europäischer Carrier

🚐 PRIVATTRANSFER
Empfang am Flughafen Valencia, privates Fahrzeug für bis zu 4 Personen, Transfer Apartment–Flughafen

💰 PREIS
Individuell vereinbart (auf Anfrage), privates Paket.

✅ TYPISCH INKLUSIVE
Rückflüge mit Umstiegen · Handgepäck · 4 Tage / 3 Nächte Luxus-Privatapartment (4 Zimmer) · Privattransfers · Organisation und Betreuung auf Kroatisch und Spanisch

➕ ZUSATZ (auf Anfrage)
Albufera · private Bootsfahrt · Gourmet · Weinverkostungen

📞 TraveLina: info@linatravelina.eu | +385 91 214 447 7`,
    es: `VALENCIA – LAS FALLAS · FIESTA VALENCIANA (paquete privado)

📌 NOTA
Este viaje ya se realizó en el marco de un encargo privado. Esta página conserva la información precontractual y el archivo del programa.

No se viene a Valencia solo por el mar o la comida, sino por la sensación de que tradición y vida moderna conviven aquí con naturalidad.

La ciudad se abre despacio: mañanas con olor a café y naranjas, paseo por el casco antiguo y luego la futurista Ciudad de las Artes y las Ciencias.

Las Fallas en marzo: fallas gigantes, petardos, fuegos; el clímax es La Crema. Más que un festival – celebración de la vida y la comunidad.

Gastronomía: paella, fideuà, tapas, horchata. Mercado Central – color y vida local.

Alojamiento: apartamento privado de lujo en pleno centro (4 dormitorios, salón amplio, cocina equipada), ubicación premium para Fallas.

🗓 17–20 mar 2025 | 4 días / 3 noches

✈️ VUELOS (indicativo)
Ida: Zagreb – Viena – Valencia · Vuelta: Valencia – Frankfurt – Zagreb
Una escala por trayecto · equipaje de mano · compañías europeas

🚐 TRANSFER PRIVADO
Acogida en el aeropuerto de Valencia, vehículo privado hasta 4 plazas, transfer apartamento–aeropuerto

💰 PRECIO
Convenido de forma individual (bajo consulta), paquete privado.

✅ INCLUÍA DE FORMA ORIENTATIVA
Vuelos de ida y vuelta con escalas · equipaje de mano · 4 días / 3 noches en apartamento privado de lujo (4 habitaciones) · transfers privados · organización y asistencia de guía en croata y español

➕ EXPERIENCIAS EXTRA (bajo consulta)
Albufera · paseo en barco privado · comidas gourmet · catas y rutas del vino

📞 TraveLina: info@linatravelina.eu | +385 91 214 447 7`,
  },
};

export function mergeValenciaIfMissing(tours) {
  if (!Array.isArray(tours) || tours.length === 0) return tours;
  if (tours.some((t) => t?.key === "valencia")) return tours;
  return [...tours, JSON.parse(JSON.stringify(VALENCIA_TOUR))];
}
